import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Shield, Users, Heart, Compass } from 'lucide-react';
export function SolutionMap() {
  const routes = [{
    icon: Eye,
    title: 'Realidad',
    desc: 'Nombrar lo que está pasando (y lo que te está costando). Dejar de minimizar tu propio desgaste.'
  }, {
    icon: Shield,
    title: 'Límites',
    desc: "Reglas claras para que tu energía no sea un recurso infinito. Aprender a decir 'no' sin culpa."
  }, {
    icon: Users,
    title: 'Reparto',
    desc: 'Pasar de reclamos vagos a acuerdos específicos. Delegar con estrategia, no con esperanza.'
  }, {
    icon: Heart,
    title: 'Recuperación',
    desc: 'Energía mínima viable para no colapsar. Pequeños actos de autocuidado que sí son posibles.'
  }, {
    icon: Compass,
    title: 'Reconstrucción',
    desc: 'Volver a ti sin abandonar a quienes amas. Recuperar tu identidad más allá del rol de cuidador.'
  }];
  return <section className="py-16 px-6 bg-white relative overflow-hidden" data-id="element-163">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-cream/50 -skew-x-12 transform translate-x-20" data-id="element-164"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 space-y-4" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy" data-id="element-167">
            La solución no es convertirte en alguien frío. <br data-id="element-168" />
            <span className="text-terracotta" data-id="element-169">Es dejar de desangrarte.</span>
          </h2>
          <p className="text-lg text-navy/80 max-w-2xl mx-auto" data-id="element-170">
            Aquí entra el{' '}
            <span className="font-bold" data-id="element-171">Mapa de Alivio del Cuidador</span>. No
            es motivación. No es "échale ganas". Es una guía para que el cuidado
            deje de comerse tu vida.
          </p>
        </motion.div>

        <div className="relative" data-id="element-172">
          {/* Vertical Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-terracotta/20 transform md:-translate-x-1/2" data-id="element-173"></div>

          <div className="space-y-8" data-id="element-174">
            {routes.map((route, index) => <motion.div key={route.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`flex flex-col md:flex-row gap-6 items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-175">
                {/* Content Side */}
                <div className="flex-1 w-full md:text-right" data-id="element-176">
                  <div className={`bg-cream p-6 rounded-xl shadow-sm border border-navy/5 ${index % 2 === 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-177">
                    <h3 className="text-xl font-serif font-bold text-navy mb-2 flex items-center gap-2 md:inline-flex" data-id="element-178">
                      <span className="text-terracotta text-sm font-sans font-bold uppercase tracking-wider" data-id="element-179">
                        Ruta {index + 1}
                      </span>
                      {route.title}
                    </h3>
                    <p className="text-navy/70 leading-relaxed" data-id="element-180">{route.desc}</p>
                  </div>
                </div>

                {/* Icon Center */}
                <div className="relative shrink-0 z-10" data-id="element-181">
                  <div className="w-16 h-16 bg-terracotta rounded-full flex items-center justify-center shadow-lg border-4 border-white" data-id="element-182">
                    <route.icon className="w-8 h-8 text-white" data-id="element-183" />
                  </div>
                </div>

                {/* Empty Side for Balance */}
                <div className="flex-1 hidden md:block" data-id="element-184"></div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}